import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg width="24" height="24" viewBox="0 0 24 24" ref={ref} {...props}>
    <title>Close</title>
    <path
      fill="currentColor"
      d="M18.3,5.71L18.3,5.71c-0.39-0.39-1.02-0.39-1.41,0L12,10.59L7.11,5.7c-0.39-0.39-1.02-0.39-1.41,0l0,0
		c-0.39,0.39-0.39,1.02,0,1.41L10.59,12L5.7,16.89c-0.39,0.39-0.39,1.02,0,1.41h0c0.39,0.39,1.02,0.39,1.41,0L12,13.41l4.89,4.89
		c0.39,0.39,1.02,0.39,1.41,0l0,0c0.39-0.39,0.39-1.02,0-1.41L13.41,12l4.89-4.89C18.68,6.73,18.68,6.09,18.3,5.71z"
    />
  </svg>
));
